<template>
	<AppCardPage
		class="create-dossier-page"
		:class="{ loading: creatingDossier }"
	>
		<AppLink :to="{ name: 'Dossiers' }" icon="arrow_back">
			Terug naar dossiers
		</AppLink>
		<AppCard title="Nieuw dossier aanmaken">
			<form @submit.prevent="submit">
				<label for="dossierName">
					<span>Naam</span>
					<input
						id="dossierName"
						ref="dossierNameInput"
						v-model="dossierName"
						type="text"
					/>
				</label>
				<AppButton
					variant="primary"
					type="submit"
					class="self-start"
					:disabled="creatingDossier"
					:loading="creatingDossier"
				>
					Maak nieuw dossier aan
				</AppButton>
			</form>
		</AppCard>
	</AppCardPage>
</template>

<script setup lang="ts">
import router from "@/router";
import { ref, onMounted } from "vue";
import { useDossierStore } from "@/store/useDossierStore";

const dossierStore = useDossierStore();
const creatingDossier = ref(false);

const dossierNameInput = ref<HTMLInputElement | null>(null);
const dossierName = ref("");

onMounted(() => {
	dossierNameInput.value?.focus();
});

async function submit() {
	creatingDossier.value = true;

	await dossierStore
		.createDossier(dossierName.value)
		.then((displayId) => {
			if (displayId) {
				return router.push({
					name: "Financieringsopzet",
					params: { dossierDisplayId: displayId },
				});
			}
		})
		.finally(() => {
			creatingDossier.value = false;
		});
}
</script>

<style lang="scss">
.create-dossier-page {
	position: relative;
	max-width: 500px;

	form {
		display: flex;
		flex-direction: column;
		gap: 1rem;
	}

	label {
		display: flex;
		flex-direction: column;

		span {
			color: var(--text-muted);
			font-size: 0.85rem;
		}

		input {
			border: 1px solid var(--border);
			border-radius: var(--border-radius);
			padding: 0.25rem 0.5rem;

			&#dossierName {
				width: 250px;
			}
		}
	}

	.error-message {
		color: var(--color-fail);
		opacity: 0;

		&.visible {
			opacity: 1;
		}
	}
}
</style>
